export { PostFeedWithErrorBoundary as PostFeed } from './PostFeedWithErrorBoundary';
